module.exports = __webpack_public_path__ + "../resources/img/ico-module-delete.30da409b.svg";